import React from 'react'
import _ from 'lodash'
import styled from 'styled-components'
import NumberFormat from 'react-number-format'

const Container = styled.div`
  text-align: center;
  font-size: 22px;
  font-weight: 700;
`

const Number = styled.span`
  color: ${props => props.theme.colors.green};
`

export default ({ value, children }) => (
  <Container>
    {children} <Number displayType='text' prefix='$' thousandSeparator as={NumberFormat} value={_.round(value)} />
  </Container>
)
